import { render, staticRenderFns } from "./PoweredByGrin.vue?vue&type=template&id=4cc6e3fa&scoped=true&"
import script from "./PoweredByGrin.vue?vue&type=script&lang=js&"
export * from "./PoweredByGrin.vue?vue&type=script&lang=js&"
import style0 from "./PoweredByGrin.vue?vue&type=style&index=0&id=4cc6e3fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cc6e3fa",
  null
  
)

export default component.exports